module.exports = __webpack_public_path__ + "img/login-background.9ccafbd7.png";